<div class="acess-main">
    <aside class="users-panel">
        <div class="panel-header">Usuários</div>
        <div class="panel-search">
            <nz-input-group [nzPrefix]="searchIcon" [nzSuffix]="clearIcon">
                <input nz-input placeholder="Filtrar usuários" [(ngModel)]="userInputFilter" (keyup)="updateFilterUser()" />
            </nz-input-group>
            <ng-template #searchIcon><nz-icon nzType="search"></nz-icon></ng-template>
            <ng-template #clearIcon>
                <nz-icon *ngIf="userInputFilter" class="clear-icon" nzType="close-circle" nzTheme="fill" (click)="clearFilterUser()"></nz-icon>
            </ng-template>
        </div>
        <nz-spin class="users-spin" [nzSpinning]="loadingUsers">
            <div class="users-list">
                <div class="user-row" *ngFor="let user of usersData"
                    [class.user-row-selected]="selectedUser != null && user.id === selectedUser.id"
                    (click)="selectUser(user)">
                    <nz-icon nzType="user"></nz-icon>
                    <span class="user-name">{{user.name}}</span>
                    <span class="user-id">{{user.id}}</span>
                </div>
                <nz-empty *ngIf="!loadingUsers && usersData.length === 0" nzNotFoundContent="Nenhum usuário encontrado"></nz-empty>
            </div>
        </nz-spin>
    </aside>

    <section class="perms-panel">
        <div class="perms-header">
            <div class="perms-title">
                <span class="title-main">Controle de Acesso</span>
                <span class="title-sub">{{selectedUser != null ? selectedUser.id + ' - ' + selectedUser.name : 'Selecione um usuário para gerenciar menus, empresas e instâncias em um só lugar'}}</span>
            </div>
            <div class="perms-actions" *ngIf="selectedUser != null">
                <button nz-button nzType="primary" nz-tooltip="Replica os acessos configurados para todas as empresas do usuário" (click)="syncAcess()">
                    <nz-icon nzType="sync"></nz-icon>Salvar Acessos
                </button>
                <button nz-button nzType="default" nz-tooltip="Copia os acessos deste usuário para outros usuários" (click)="openCopyAcessPopUp()">
                    <nz-icon nzType="copy"></nz-icon>Copiar Acessos
                </button>
            </div>
        </div>

        <div class="perms-empty" *ngIf="selectedUser == null">
            <nz-empty nzNotFoundContent="Nenhum usuário selecionado"></nz-empty>
        </div>

        <div class="perms-body" *ngIf="selectedUser != null">
            <nz-collapse>
                <nz-collapse-panel [nzHeader]="'Menus do Sistema'" [(nzActive)]="menusOpen">
                    <app-menu-view [user]="selectedUser"></app-menu-view>
                </nz-collapse-panel>
                <nz-collapse-panel [nzHeader]="'Empresas'" [(nzActive)]="companiesOpen">
                    <app-companies-view [user]="selectedUser"></app-companies-view>
                </nz-collapse-panel>
                <nz-collapse-panel [nzHeader]="'Instâncias / Ações'" [(nzActive)]="instancesOpen">
                    <app-instances-action-view [user]="selectedUser"></app-instances-action-view>
                </nz-collapse-panel>
            </nz-collapse>
        </div>
    </section>
</div>
